import { render, staticRenderFns } from "./CarbonPath.vue?vue&type=template&id=4888458a&scoped=true"
import script from "./CarbonPath.vue?vue&type=script&lang=js"
export * from "./CarbonPath.vue?vue&type=script&lang=js"
import style0 from "./CarbonPath.vue?vue&type=style&index=0&id=4888458a&prod&scoped=true&lang=scss"
import style1 from "./CarbonPath.vue?vue&type=style&index=1&id=4888458a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4888458a",
  null
  
)

export default component.exports